import { useNavigate } from 'react-router'
import { LayoutLibrary } from '../..'
import { Responsive } from '../../../common/Responsive'
import { FilterCompanySetting } from '../../../common/filterCompany/filterSetting'
import { ROUTE_LIBRARY } from '../../constant'

const FilteredSetting = () => {
  const navigate = useNavigate()

  const backToFilteredCompanies = () => {
    navigate(ROUTE_LIBRARY.FILTERED_COMPANIES)
  }

  const renderContent = (isResponsive) => {
    return (
      <div
        className="h100"
        style={
          isResponsive
            ? {
                paddingTop: 16,
                paddingBottom: 12,
              }
            : {}
        }
      >
        <FilterCompanySetting
          buttonBackProps={{
            text: 'library.main.BACK_TO_COMPANY_FILTER',
            onClick: backToFilteredCompanies,
          }}
          onSave={backToFilteredCompanies}
          onSaveDefault={backToFilteredCompanies}
        />
      </div>
    )
  }

  return (
    <Responsive renderResponsive={() => renderContent(TextTrackCueList)}>
      <LayoutLibrary
        renderBottomComponent={renderContent}
        isShowFooter={false}
      />
    </Responsive>
  )
}

export default FilteredSetting
